import {
  cloneDeep,
  isEmpty,
  isUndefined,
} from '../../../utilities/GeneralUtils'

export const actOnChildren = function (children, action, multichildCtrs) {
  const childr = children
  if (!isEmpty(children) && children.length > 0) {
    for (const input of children) {
      // console.log(input.fieldName + '/' + action.fieldName)
      if (input.fieldName === action.fieldName) {
        if (action.name === 'add') {
          const clonedTemplate = cloneDeep(input.template)
          clonedTemplate.name += `_${getMultichildCtr(
            clonedTemplate.name,
            multichildCtrs,
          )}`
          actOnChildren(clonedTemplate.template, {
            name: 'rename',
            fieldName: clonedTemplate.name,
          })
          input.currentTemplateValues =
            input.currentTemplateValues.concat(clonedTemplate)
          // console.log('actOnChildren')
          // console.log(input.currentTemplateValues)
        } else if (action.name === 'delete') {
          for (let i = 0; i < input.currentTemplateValues.length; i++) {
            const templateItem = input.currentTemplateValues[i]
            if (templateItem.name === action.template.name) {
              input.currentTemplateValues.splice(i, 1)
              break
            }
          }
        }
      } else {
        actOnInput(input, action, multichildCtrs)
      }
    }
  }

  // return childr
}

export const actOnInputOptions = function (input, action, multichildCtrs) {
  if (!isUndefined(input.options) && input.options.length > 0) {
    for (const option of input.options) {
      actOnChildren(option.children, action, multichildCtrs)
      // console.log('actOnInputOptions')
      // console.log(option.children)
    }
  }
}

export const actOnInput = function (input, action, multichildCtrs) {
  if (!isUndefined(input)) {
    if (action.name === 'rename') {
      input.fieldName += `_${action.fieldName}`
      // console.log('--------- rename')
      // console.log(input)
    }
    if (!isUndefined(input.options) && input.options.length > 0) {
      actOnInputOptions(input, action, multichildCtrs)
    }
  }
}

export const actOnSection = function (section, action, multichildCtrs) {
  if (!isEmpty(section.children) && section.children.length > 0) {
    actOnChildren(section.children, action, multichildCtrs)
  }
}

export const actOnData = function (data, action, multichildCtrs) {
  if (!isEmpty(data.sections) && data.sections.length > 0) {
    for (const section of data.sections) {
      actOnSection(section, action, multichildCtrs)
    }
  }

  return data
}

export const getMultichildCtr = function (multichildName, multichildCtrs) {
  if (isUndefined(multichildCtrs[multichildName])) {
    multichildCtrs[multichildName] = 0
  } else {
    multichildCtrs[multichildName] += 1
  }

  return multichildCtrs[multichildName]
}

export const addMultichildCtrsToObject = function (srcObj, multichildCtrs) {
  if (!isUndefined(srcObj) && !isUndefined(multichildCtrs)) {
    for (const key in multichildCtrs) {
      // eslint-disable-next-line no-prototype-builtins
      if (multichildCtrs.hasOwnProperty(key)) {
        srcObj[`${key}_ctr`] = multichildCtrs[key]
      }
    }
  }
}
